import { AiFillAppstore } from "react-icons/ai";
import { RiUserLocationFill } from "react-icons/ri";
import { IoPeople, IoSettings } from "react-icons/io5";
import { FaPhoneVolume } from "react-icons/fa6";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { MdManageAccounts } from "react-icons/md";
import { FaWallet } from "react-icons/fa";
import { MdInsertChart } from "react-icons/md";
import { IoIosListBox } from "react-icons/io";
import { IoTimeSharp } from "react-icons/io5";
import { MdVerified } from "react-icons/md";
import { MdSupportAgent } from "react-icons/md";
import { MdForum } from "react-icons/md";
import { MdHistory } from "react-icons/md";

const menu = [
  {
    heading: "Dashboard",
    icon: () => <AiFillAppstore />,
    rootPath: "/",
    submenu: [],
  },
  {
    heading: "Bookings",
    icon: () => <RiUserLocationFill />,
    rootPath: "/bookings",
    submenu: [
      {
        label: "Add Trip",
        path: "/bookings/lead/search",
        activePath: "/bookings/lead",
      },
      {
        label: "View Bookings",
        path: "/bookings"
      },
      {
        label: "Tour Packages",
        path: "/bookings/packages",
      }
    ],
  },
  {
    heading: "Dispatch",
    icon: () => <IoSettings />,
    rootPath: "/dispatch",
    submenu: [],
  },
  {
    heading: "Reports",
    icon: () => <MdInsertChart />,
    rootPath: "/reports",
    submenu: [
      {
        label: "Create Report",
        path: "/reports/create",
      },
      {
        label: "View Report",
        path: "/reports/view",
      },
      {
        label: "Stats",
        path: "/stats",
      },
    ],
  },
  {
    heading: "Fleet Management",
    icon: () => <IoIosListBox />,
    rootPath: "/fleet-management",
    submenu: [
      {
        label: "Vehicles",
        path: "/fleet-management/vehicles",
      },
      {
        label: "Drivers",
        path: "/fleet-management/driver",
      },
      {
        label: "Vendors",
        path: "/fleet-management/vendor",
      },
    ],
  },
  {
    heading: "Verification Center",
    icon: () => <MdVerified />,
    rootPath: "/verification",
    submenu: [
      {
        label: "Driver Approvals",
        path: "/verification/driver-approvals",
      },
      {
        label: "Vehicle Approvals",
        path: "/verification/vehicle-approvals",
      },
      {
        label: "Vendor Approvals",
        path: "/verification/vendor-approvals",
      },
      {
        label: "Awaiting Clarification",
        path: "/verification/awaiting-clarification",
      },
      {
        label: "Vendor Onboarding Config",
        path: "/verification/vendor-onboarding-config",
      },
    ],
  },
  {
    heading: "Operations Setup",
    icon: () => <MdManageAccounts />,
    rootPath: "/management",
    submenu: [
      {
        label: "Vehicle Segments",
        path: "/management/vehicles",
      },
      {
        label: "Custom Booking",
        path: "/management/custom-booking",
      },
      {
        label: "Tour Package Management",
        path: "/management/packages",
      },
      {
        label: "State Tax List",
        path: "/management/taxes",
      },
      {
        label: "Terms and Conditions",
        path: "/management/terms-and-conditions",
      },
    ],
  },
  {
    heading: "Customer Management",
    icon: () => <FaPhoneVolume />,
    rootPath: "/customer-management",
    submenu: [
      {
        label: "Customer List",
        path: "/management/customer",
      },
      {
        label: "Booking History",
        path: "/history",
      },
      {
        label: "Customer Policies",
        path: "/customer-policies",
      },
    ],
  },
  {
    heading: "Finance",
    icon: () => <IoPeople />,
    rootPath: "/finance",
    submenu: [
      {
        label: "Customer",
        path: "/finance/customer",
      },
      {
        label: "Driver",
        path: "/finance/driver",
      },
      {
        label: "Vendor",
        path: "/finance/vendor",
      },
      {
        label: "Generate Invoice and Receipts",
        path: "/finance/invoice-receipts",
      }
    ],
  },
  {
    heading: "Access Control",
    icon: () => <IoSettings />,
    rootPath: "/settings",
    submenu: [],
  },
  {
    heading: "Support Center",
    icon: () => <MdSupportAgent />,
    rootPath: "/support",
    submenu: [],
  },
  {
    heading: "Communication",
    icon: () => <MdForum />,
    rootPath: "/communication",
    submenu: [],
  },
  {
    heading: "System Logs",
    icon: () => <MdHistory />,
    rootPath: "/system-logs",
    submenu: [],
  },
];

export { menu };
